import { render, staticRenderFns } from "./Lgx174208127858638848.vue?vue&type=template&id=2b86c244&"
import script from "./Lgx174208127858638848.vue?vue&type=script&lang=js&"
export * from "./Lgx174208127858638848.vue?vue&type=script&lang=js&"
import style0 from "./Lgx174208127858638848.vue?vue&type=style&index=0&id=2b86c244&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports